// Sport configuration — a single source of truth for all sport-specific UI in
// the reporting app.
//
// `ReportingSportConfig` is a class. Each sport (soccer / AMF / CFL) is a
// subclass that passes its static data to the base constructor. The active
// unit system is wired in at construction time by `getReportingSportConfig`
// so formatters reading `config.unitSystem` / `config.formatPeriodName(n)`
// use the right conversion + period word without the caller threading them through.
//
// Adding a sport = drop in a new file, register the class below.
import { ReportingSport } from '@frontend/core/lib/domains/reporting/types'
import type { UnitSystem } from '@frontend/core/lib/domains/units/types'
import { AmericanFootballConfig } from './amf'
import { ReportingSportConfig } from './base'
import { CanadianFootballConfig } from './canadian-football'
import { SoccerConfig } from './soccer'

export { AmericanFootballConfig } from './amf'
export { ReportingSportConfig, type ReportingSportData } from './base'
export { CanadianFootballConfig } from './canadian-football'
export { SoccerConfig } from './soccer'
export * from './types'

export function getReportingSportConfig(
  sport: ReportingSport,
  unitSystem: UnitSystem
): ReportingSportConfig {
  switch (sport) {
    case ReportingSport.AmericanFootball:
      return new AmericanFootballConfig(unitSystem)
    case ReportingSport.CanadianFootball:
      return new CanadianFootballConfig(unitSystem)
    case ReportingSport.Soccer:
    default:
      return new SoccerConfig(unitSystem)
  }
}
